/**
 * CandidateAvatar — LinkedIn/Apollo photo with initials fallback.
 *
 * Any candidate card in the app should use this component so we get a
 * consistent look. Size prop controls both dimension and font-size.
 */
import React, { useState } from "react";

const PALETTE = [
    { bg: "#FF5A00", fg: "#fff" },
    { bg: "#F59E0B", fg: "#111" },
    { bg: "#22C55E", fg: "#fff" },
    { bg: "#0A66C2", fg: "#fff" },
    { bg: "#A855F7", fg: "#fff" },
    { bg: "#EF4444", fg: "#fff" },
    { bg: "#0EA5E9", fg: "#fff" },
    { bg: "#EC4899", fg: "#fff" },
];

function initials(name) {
    if (!name) return "?";
    const parts = String(name).trim().split(/\s+/).slice(0, 2);
    return parts.map((p) => p[0]?.toUpperCase() || "").join("") || "?";
}

function paletteFor(name) {
    if (!name) return PALETTE[0];
    let sum = 0;
    for (let i = 0; i < name.length; i++) sum += name.charCodeAt(i);
    return PALETTE[sum % PALETTE.length];
}

export default function CandidateAvatar({ name, url, size = 44, className = "", testid }) {
    const [errored, setErrored] = useState(false);
    const showImg = url && !errored;
    const p = paletteFor(name);
    const style = { width: size, height: size, fontSize: Math.round(size * 0.4) };
    if (showImg) {
        return (
            <img
                src={url}
                onError={() => setErrored(true)}
                alt={name || "avatar"}
                data-testid={testid}
                style={style}
                className={`rounded-full object-cover border border-white/12 bg-[var(--jr-surface-2)] shrink-0 ${className}`}
            />
        );
    }
    return (
        <div
            data-testid={testid}
            style={{ ...style, background: p.bg, color: p.fg }}
            className={`rounded-full grid place-items-center font-display font-semibold shrink-0 border border-white/12 ${className}`}
        >
            {initials(name)}
        </div>
    );
}
